import React from 'react';

import * as Styled from './progress-bar.style';

const calcPercentage = (step: number, total: number) =>
  step >= total ? 100 : ((step - 1) / (total - 1)) * 100;

export type ProgressBarProps = {
  current: number;
  previous: number;
  total: number;
};

export const ProgressBar: React.FC<ProgressBarProps> = ({
  current,
  previous,
  total,
}) => {
  const initialPercentage = calcPercentage(previous, total);
  const animatePercentage = calcPercentage(current, total);

  return (
    <Styled.ProgressContainer>
      <Styled.ProgressBar $start={initialPercentage} $end={animatePercentage} />
    </Styled.ProgressContainer>
  );
};
